import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const productService = {
  /**
   * Get all products with optional filters
   * @param {object} filters - Filter options
   * @returns {Promise<{products: Array, total: number}>}
   */
  async getProducts(filters = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filters.category) params.append('category', filters.category);
      if (filters.featured !== undefined) params.append('featured', filters.featured);
      if (filters.bestseller !== undefined) params.append('bestseller', filters.bestseller);
      if (filters.in_stock !== undefined) params.append('in_stock', filters.in_stock);
      if (filters.page) params.append('page', filters.page);
      if (filters.page_size) params.append('page_size', filters.page_size);
      
      const response = await axios.get(`${API}/products?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

  /**
   * Get a single product by ID
   * @param {string} productId - Product ID (SKU)
   * @returns {Promise<object>}
   */
  async getProduct(productId) {
    try {
      const response = await axios.get(`${API}/products/${productId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching product ${productId}:`, error);
      throw error;
    }
  },

  /**
   * Get all unique categories
   * @returns {Promise<Array<string>>}
   */
  async getCategories() {
    try {
      const response = await axios.get(`${API}/products/categories/list`);
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },

  /**
   * Get featured products
   * @returns {Promise<{products: Array}>}
   */
  async getFeaturedProducts() {
    return this.getProducts({ featured: true, page_size: 50 });
  },

  /**
   * Get bestseller products
   * @returns {Promise<{products: Array}>}
   */
  async getBestsellers() {
    return this.getProducts({ bestseller: true, page_size: 50 });
  },

  /**
   * Get products by category
   * @param {string} category - Category name
   * @returns {Promise<{products: Array}>}
   */
  async getProductsByCategory(category) {
    return this.getProducts({ category, page_size: 50 });
  }
};
